import { EkaFocosableElement } from '../../../common/types/EkaFocusable';
import { CalculatorConfigType } from './calculatorsTypes';
import AntSelect from './padV2/AntSelect';

export const CalculatorSelect: React.FC<{
    argsKey: string;
    config: CalculatorConfigType;
    onValueChange: (name: string, value: string, type?: 'unitSwitchers' | 'valueSelects') => void;
    setPropertyInputRef: (ref: EkaFocosableElement | null, index: number, subIndex: number) => void;
    index: number;
    handleNextFocus: (index: number, subIndex: number) => void;
}> = ({ argsKey, config, onValueChange, setPropertyInputRef, index, handleNextFocus }) => {
    const arg = config?.calculator?.definition?.args?.[argsKey];
    const valueSelects = config?.calculator?.definition?.valueSelects[arg?.valueSelectId];
    const valueSelectsOptions = valueSelects.map((item, i) => ({
        ...item,
        id: item.value,
        value: item.name,
    }));

    const defaultValue = valueSelects.find((option) => option.value === arg?.default);

    return (
        <AntSelect
            className="bg-darwin-neutral-50 text-darwin-neutral-600 w-full"
            showArrow={true}
            customDropdownWidth={180}
            allowClear={false}
            placeholder={defaultValue?.name}
            optionFilterProp="children"
            options={valueSelectsOptions}
            setRef={(ref) => {
                setPropertyInputRef(ref, index, 0);
            }}
            setValue={(option) => {
                option?.value &&
                    arg.default !== option?.value &&
                    onValueChange(arg?.name, option.id, 'valueSelects');

                handleNextFocus(index + 1, 0);
            }}
            filterOption={true}
            value={valueSelectsOptions.find((opt) => arg?.default === opt.id) || undefined}
            getValue={(o) => o?.id}
            getLabelToCompare={(o) => o.value}
        />
    );
};
